export default __webpack_public_path__ + "static/media/scrum_board.6d72b25b.svg";